// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2Ey9A","right":"styles_right__30Grx"};